// src/pages/AdminPage/components/Toast.tsx
import { Check, X } from "lucide-react";
import type { ToastState } from "../utils/adminTypes";

interface ToastProps {
  toast: ToastState | null;
}

export default function Toast({ toast }: ToastProps) {
  if (!toast) return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 24,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 300,
        animation: "toastIn .3s ease",
      }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          padding: "12px 20px",
          borderRadius: 14,
          background: "#111827",
          border: `1px solid ${
            toast.type === "success" ?
              "rgba(34,197,94,.4)"
            : "rgba(239,68,68,.4)"
          }`,
          boxShadow: "0 8px 32px rgba(0,0,0,.4)",
        }}>
        {toast.type === "success" ?
          <Check size={16} color="#22C55E" />
        : <X size={16} color="#EF4444" />}
        <span
          style={{
            color: "#E2E8F0",
            fontSize: 13,
            fontWeight: 600,
            whiteSpace: "nowrap",
          }}>
          {toast.msg}
        </span>
      </div>
    </div>
  );
}
